// Numéro WhatsApp de Thibault (compte relié à Unipile), au format
// international sans "+" ni espaces, comme l'attend wa.me. Vide = la bulle
// WhatsApp n'est pas affichée.
export const WHATSAPP_NUMBER = "33635389512";

export function whatsappUrl(message: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export const WHATSAPP_MESSAGE = "Bonjour Thibault, je viens de votre site";
